import * as React from "react";
import { Dismiss20Regular } from "@fluentui/react-icons";
import { ILookupDictionary } from "../../../../lookup/types/ILookupDictionary";
import { updateRepresentationSelector } from "../../../../redux/reducers/RepertoireReducer";
import IRepertoireComponentDataItem from "../../../../redux/types/IRepertoireComponentDataItem";
import { IIPRepresentation } from "../../../types/IIPRepresentation";
import { WideActionButton } from "../../actionButton/ActionButton";
import { Dropdown } from '@fluentui/react/lib/Dropdown';
import { REPERTOIRE_PAGE_FORM_ITEM_SIZE, TEXT_INPUT } from "../../../Consts";
import { IDropdownOption } from "@fluentui/react";
import { IUsagePool } from "../../../types/usageTypes/IUsagePool";
import { SizedRadiobuttonDataInput } from "../../radioButtonDataInput/RadiobuttonDataInput";

export interface IPoolSelectionViewProps {
    interestedPartyRepresentation: IIPRepresentation;
    hideModal: () => void;
    updateRepresentationSelector: typeof updateRepresentationSelector;
    dataGridTableData: IRepertoireComponentDataItem,
    lookupValues: ILookupDictionary;
    isReadOnly?: boolean;
    incrementTempID?: () => void;
    title?: string;
    modalIndex?: number;
    pools: IUsagePool[];
}

interface IPoolSelectionViewState {
    representation: IIPRepresentation;
    setPools: any[];
    setPoolsCategory: any[];
    poolOptions: any[];
    poolCategoryOptions: any[];
    allOptionSelected: boolean;
    isPoolEnabled: boolean;
    isPoolCategoryEnabled: boolean;
}

export default class PoolSelectionView extends React.PureComponent<IPoolSelectionViewProps, IPoolSelectionViewState> {

    constructor(props: IPoolSelectionViewProps) {
        super(props);
        this.state = {
            representation: this.props.interestedPartyRepresentation, 
            setPools:[],
            setPoolsCategory:[],
            poolOptions:[],
            poolCategoryOptions:[],
            allOptionSelected: false,
            isPoolEnabled: true,
            isPoolCategoryEnabled: false,
        }
    }

    componentDidMount() {
        const { interestedPartyRepresentation, title, pools, lookupValues } = this.props;
        let updatedPools = [];
        let updateSetPools = [];
        let selectedPools = [];
        let updatedPoolCategories = [];
        let updateSetPoolCategories = [];
        let selectedPoolCategories = [];
               
        if (interestedPartyRepresentation) {
            if (title === 'Pools Include') {

                updatedPools = interestedPartyRepresentation.includePools.value
                    .split("Pool Categories:")[0]
                    .replace(/^Pools:/, '')
                    .replace(/;$/, '')        
                    .split(";");

                if (interestedPartyRepresentation.includePoolCategories) {
                    if(!interestedPartyRepresentation.includePoolCategories.value.includes("Pool:ALL")){
                        updatedPoolCategories = interestedPartyRepresentation.includePoolCategories.value.split(";");
                    }
                }
            } else {
                updatedPools = interestedPartyRepresentation.excludePools.value
                    .split("Pool Categories:")[0]
                    .replace(/^Pools:/, '')
                    .replace(/;$/, '')        
                    .split(";");

                if (interestedPartyRepresentation.excludePoolCategories) {
                    updatedPoolCategories = interestedPartyRepresentation.excludePoolCategories.value.split(";");                  
                }
            }

            if (!updatedPools.includes('')) {

                if (updatedPools.includes('ALL')) {
                    let allOption = { key: 0, text: "ALL", data: "ALL" };
                    selectedPools.push(allOption);
                }
                else {
                    updatedPools.map(x => {
                        updateSetPools.push((pools.find(item => item.poolCode === x)))
                    })

                    updateSetPools.map(s => {
                        selectedPools.push({ key: s.poolId, data: s.poolId, text: s.poolCode, selected: true })
                    })
                }                
                                
                this.setState({ setPools: selectedPools})
            }

            if(!updatedPoolCategories.includes('')){

                if(updatedPoolCategories[0].includes('ALL')){
                    this.setState({ setPoolsCategory: selectedPoolCategories})                
                }
                else {
                    updatedPoolCategories.map(x => {
                        updateSetPoolCategories.push(lookupValues.PoolCategory.lookups.find(item => item.code === x))
                    })

                    updateSetPoolCategories.map(s => {
                        selectedPoolCategories.push({ key: s.typeID, data: s.code, text: s.description, selected: true })
                    })                            
                                    
                    this.setState({ setPoolsCategory: selectedPoolCategories})      
                }                         
            }        
        }
    }

    updatePoolSelectorState = (value: any, field: string) => {
        switch (field) {

            case "Pool":
                this.setState({
                    isPoolEnabled: true,
                    isPoolCategoryEnabled: false
                });
                break;
            case "Pool Category":
                this.setState({
                    isPoolCategoryEnabled: true,
                    isPoolEnabled: false
                });
                break;
        }
    };

    multiSelectChangePoolData = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption, index?: number) => {
        const { setPools } = this.state;        

        let result = [];
        if (option.key === 0 && option.selected == true) {
            result.push(option)
            this.setState({ setPools: result }) 
        } else {

            if (setPools.length) {
                result = [...new Set(setPools)].map(x => { return x })
            }

            if (option.key != 0 && result.filter(x => x.key == 0).length > 0) {
                result.splice(0, 1);
            }

            if (result.filter(x => x.key == option.key).length == 0) {
                result.push(option)
            }
            else {
                const index = result.map(x => x.key).indexOf(option.key);
                if (index > -1) {                
                    result.splice(index, 1);
                }
            }

            this.setState({ setPools: result })     
        }          
    }

    multiSelectChangePoolCategoryData = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption, index?: number) => {
        const { setPoolsCategory } = this.state;        

        let result = [];
        if (option.key === 0 && option.selected == true) {
            result.push(option)
            this.setState({ setPoolsCategory: result }) 
        } else {

            if (setPoolsCategory.length) {
                result = [...new Set(setPoolsCategory)].map(x => { return x })
            }

            if (option.key != 0 && result.filter(x => x.key == 0).length > 0) {
                result.splice(0, 1);
            }

            if (result.filter(x => x.key == option.key).length == 0) {
                result.push(option)
            }
            else {
                const index = result.map(x => x.key).indexOf(option.key);
                if (index > -1) {                
                    result.splice(index, 1);
                }
            }

            this.setState({ setPoolsCategory: result })     
        }          
    }

    render() {
        const { representation, setPools, isPoolEnabled, isPoolCategoryEnabled, setPoolsCategory } = this.state;
        const { hideModal, isReadOnly, title, pools, interestedPartyRepresentation, modalIndex, updateRepresentationSelector,lookupValues } = this.props;                 
        
        let buttonSaveAction = () => {
            if (!interestedPartyRepresentation) return;

            const repId = interestedPartyRepresentation.representationID ?? modalIndex;
            const isIncludeMode = title === "Pools Include";

            const selectedAllPools = setPools.some(p => p.key === 0);

            const poolCodes = selectedAllPools
            ? setPools.find(p => p.key === 0)?.text ?? ""
            : setPools
                .map(p => pools.find(item => item.poolId === p.key)?.poolCode)
                .filter((code): code is string => Boolean(code))
                .join(";");            
            
            const categoryDescription = setPoolsCategory
                .map(c => lookupValues["PoolCategory"].lookups.find(item => item.typeID === c.key)?.description)
                .filter((code): code is string => Boolean(code))
                .join(";");   
                
            const categoryCodes = setPoolsCategory
                .map(c => lookupValues["PoolCategory"].lookups.find(item => item.typeID === c.key)?.code)
                .filter((code): code is string => Boolean(code))
                .join(";");   


            const segments: string[] = [];
            if (poolCodes.length) {
                segments.push(`Pools:${poolCodes}`);
            }
            if (categoryDescription.length) {
                segments.push(`Pool Categories:${categoryDescription}`);
            }
            const segmentsString = segments.join(';');
            
            const resultRep: IIPRepresentation = {
                ...representation,
                ...(selectedAllPools
                ? {
                    allPoolsIncluded: true,
                    includePools: { value: segmentsString, inputType: TEXT_INPUT },
                    }
                : isIncludeMode
                ? {
                    allPoolsIncluded: false,
                    includePools: { value: segmentsString, inputType: TEXT_INPUT },
                    }
                : {
                    excludePools: { value: segmentsString, inputType: TEXT_INPUT },
                    }),
                ...(isIncludeMode
                ? {
                    includePoolCategories: { value: categoryCodes, inputType: TEXT_INPUT },
                    }
                : {
                    excludePoolCategories: { value: categoryCodes, inputType: TEXT_INPUT },
                    }),
            };

            updateRepresentationSelector(repId, resultRep);
            hideModal();                        
        };

        let buttonCloseAction = () => {
            hideModal();
        };
       
        let poolOptions = [];
        let poolCategoryOptions = [];
        let filteredPools = [];

        if (pools) {
            filteredPools = pools.filter(k => k.rights.some(e => e.economicRight == interestedPartyRepresentation.economicRights.value));
            filteredPools.map(x => poolOptions.push({ key: x.poolId, text: x.poolCode, data: x.poolId, poolCategory: x.poolCategory }));

            poolOptions.sort((a, b) => a.text.localeCompare(b.text));       

            if (title === 'Pools Include') {
                let allOption = { key: 0, text: "ALL", data: "ALL" };
                poolOptions.unshift(allOption);
            }
        }

        let poolCategories = Array.from(new Set(filteredPools.map(x => x.poolCategory)));

        const filteredOptions = lookupValues["PoolCategory"].lookups
            .filter(x => poolCategories.includes(x.code))
            .map(x => ({
                key: x.typeID,
                text: x.description,
                data: x.code
            }));

        poolCategoryOptions = filteredOptions;

        let buttonDeselectAction = (value: any,source: string) => {
            let updatedPoolsCategory = [];
            if (source === "Pool") {
                updatedPoolsCategory = setPools.filter(item => item.key !== value.key);
                this.setState({ setPools: updatedPoolsCategory })            
            } else if (source === "Pool Category") {
                updatedPoolsCategory = setPoolsCategory.filter(item => item.key !== value.key);
                this.setState({ setPoolsCategory: updatedPoolsCategory })            
            }
        };

        if (representation) {

            return (
                <div className="modal-dialog settingsModal" style={{ width: 952 }}>
                    <div className="modal-content">
                        <div style={{ height: 'auto', background: 'white' }}>
                            <div className='modal-header' style={{
                                background: "#38429C",
                                color: "white",
                            }}>
                            <button type="button" className="close" data-dismiss="modal" aria-hidden="true" onClick={() => hideModal()}>
                                <Dismiss20Regular title="Close" />
                            </button>
                            <h1 className="modal-title">{title}</h1>
                            </div>
                            <div style={{ padding: 15 }}>
                                <div className="row">
                                    <div style={{ display: 'flex', flexDirection: 'row', fontSize: 15, top: 0 }}>
                                        <SizedRadiobuttonDataInput
                                            onSelectionChange={(value) => this.updatePoolSelectorState(value, "Pool")}
                                            disabled={false}
                                            radioName=""
                                            title=""
                                            options={[
                                                { desc: "Pool", code: 'P' }
                                            ]}
                                            selectedValue={isPoolEnabled ?
                                                'P' :
                                                ''} />
                                        <SizedRadiobuttonDataInput
                                            onSelectionChange={(value) => this.updatePoolSelectorState(value, "Pool Category")}
                                            disabled={false}
                                            radioName=""
                                            title=""
                                            options={[
                                                { desc: "Pool Category", code: 'PC' }
                                            ]}
                                            selectedValue={isPoolCategoryEnabled ?
                                                'PC' :
                                                ''} />
                                    </div>                            
                                    {isPoolEnabled && poolOptions && <>
                                        <div className={REPERTOIRE_PAGE_FORM_ITEM_SIZE}>
                                            <div style={{ height: '100', position: 'relative', width: 920, overflow: 'hidden' }}>
                                                <Dropdown
                                                    label={"Pools"}
                                                    selectedKeys={setPools.map(x => x.key)}
                                                    options={poolOptions}
                                                    multiSelect={true}
                                                    onChange={this.multiSelectChangePoolData}
                                                    placeholder={"No Pools selected."}
                                                    styles={{
                                                        title: { height: 40, backgroundColor: "WhiteSmoke", borderWidth: 1, borderColor: "LightGray", padding: 4, width: 400 },
                                                        dropdownItems: { height: 200 }

                                                    }}
                                                    disabled={false}
                                                    dropdownWidth={920} />
                                            </div>
                                        </div>  
                                    </>} 
                                     {isPoolCategoryEnabled && poolCategoryOptions && <>
                                        <div className={REPERTOIRE_PAGE_FORM_ITEM_SIZE}>
                                            <div style={{ height: '100', position: 'relative', width: 920, overflow: 'hidden' }}>
                                                <Dropdown
                                                    label={"Pool Categories"}
                                                    selectedKeys={setPoolsCategory.map(x => x.key)}
                                                    options={poolCategoryOptions}
                                                    multiSelect={true}
                                                    onChange={this.multiSelectChangePoolCategoryData}
                                                    placeholder={"No Pools Categories selected."}
                                                    styles={{
                                                        title: { height: 40, backgroundColor: "WhiteSmoke", borderWidth: 1, borderColor: "LightGray", padding: 4, width: 400 },
                                                        dropdownItems: { height: 200 }

                                                    }}
                                                    disabled={false}
                                                    dropdownWidth={920} />
                                            </div>
                                        </div>  
                                    </>}

                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                    <div className="selected-item-container">
                                        <div style={{ fontSize: 13, fontWeight: 600 }}>Selected items</div>
                                        <hr style={{ borderBottom: 2 }}></hr>
                                        <div style={{ maxHeight: 200, overflowY: 'scroll' }}>
                                            <div className="selected-items-list">
                                                {setPools && setPools.map((x, index) => {
                                                    return <div className="selected-item">
                                                        <span>{x.text}</span> &nbsp;&nbsp;
                                                        <span className="close-icon" onClick={() => buttonDeselectAction(x, "Pool")}>&times;</span>
                                                    </div>
                                                })}
                                                {setPoolsCategory && setPoolsCategory.map((x, index) => {
                                                    return <div className="selected-item">
                                                        <span>{x.text}</span> &nbsp;&nbsp;
                                                        <span className="close-icon" onClick={() => buttonDeselectAction(x, "Pool Category")}>&times;</span>
                                                    </div>
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr style={{ borderBottom: 2 }}></hr>

                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <WideActionButton
                                        buttonText="Cancel"
                                        buttonAction={buttonCloseAction}
                                        disabled={isReadOnly}
                                        className="button btn-defaultSecondary" />
                                    <WideActionButton
                                        buttonText="Save"
                                        buttonAction={buttonSaveAction}
                                        disabled={isReadOnly} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        else return <div></div>
    }

}
